import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import ClientDetailsApp from "./ClientDetailsApp";
import TwoColumnLayout from "layout/TwoColumnLayout";
import UserActionPanel from "systemsettings/menu/UserActionPanel";
import ClientDetailOptionsPanel from "./ClientDetailOptionsPanel";
import ClientActivityPanel from "./Activity/ClientActivityPanel";
import { useLoaderData } from "react-router";

const ClientDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ClientDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <ClientDetailsApp {...viewModel} />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>

      <ClientDetailOptionsPanel
        client={viewModel.client}
        activeSubscription={viewModel.activeSubscription}
        optionsPanel={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
      />

      <ClientActivityPanel
        config={viewModel.activityPanel}
        clientId={viewModel.client.clientId}
      />

      <UserActionPanel
        key="userActivities"
        title="User activity"
        userActions={viewModel.userActivities}
        displayRemoteAddress={false}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default ClientDetailApp;